// $('.stuff').html("blarg")
export function setHtmlBySelector(selector, content) {
  for (let i of document.querySelectorAll(selector)) {
    i.innerHTML = content;
  }
}

// $('.stuff').val("blarg");
export function setValBySelector(selector, content) {
  for (let i of document.querySelectorAll(selector)) {
    i.value = content;
  }
}

// $(document).on("change", ".stuff", handler);
// WILL NOT WORK WITH NON-BUBBLING EVENTS LIKE BLUR.
export function addHandlerBySelector(selector, eventType, handler) {
  document.addEventListener(eventType, (e) => {
    if (e.target.matches(selector)) {
      handler(e);
    }
  });
}

// $('.stuff').removeClass("foo");
export function removeClassBySelector(selector, klassName) {
  for (let i of document.querySelectorAll(selector)) {
    i.classList.remove(klassName);
  }
}

// $('.stuff').addClass("foo");
export function addClassBySelector(selector, klassName) {
  for (let i of document.querySelectorAll(selector)) {
    i.classList.add(klassName);
  }
}

// $('.stuff').length > 0
export function selectorPresent(selector) {
  return document.querySelectorAll(selector).length > 0;
}

export function getMeta(selector) {
  const ele = document.querySelector(selector);
  return ele ? ele.content : undefined;
}
